import React from 'react';
import styled from 'styled-components';

import { blue, white } from 'utils/style/colors';
import { convertDigitToProperFormat } from '../../../utils/number';
import i18n from '../../../i18n';

const BoxWrapper = styled.div`
  padding: 0.7rem;
  margin: 0.5rem;
  background-color: ${(props) => (props.color ? props.color : blue)};
  color: ${white};
  border: 1px solid;
  border-color: ${(props) => (props.color ? props.color : blue)};
  border-radius: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease;
  flex: 1 auto;
  &:hover {
    border-color: black;
  }
`;

const Title = styled.span`
  white-space: pre-wrap;
`;
const NumberSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
`;

const Count = styled.span`
  font-size: 1.8rem;
  color: var(--exact-white);
  & > span {
    font-size: 1rem;
  }
`;

export interface IInfoBoxProps {
  value: number | string;
  percentage?: number;
  text: string;
  totalCount?: number;
  color?: string;
}

const InfoBox: React.FC<IInfoBoxProps> = ({
  value,
  percentage,
  text,
  totalCount,
  color,
}) => {
  return (
    <BoxWrapper color={color}>
      <Title>{text}</Title>
      <NumberSection>
        <Count color={color}>
          {convertDigitToProperFormat(value)}
          {totalCount !== undefined && (
            <span>
              {
                i18n.t('fromNumber', {
                  ns: 'taskManager',
                  number: convertDigitToProperFormat(totalCount),
                }) as string
              }
            </span>
          )}
        </Count>
        <span style={{ color: `${white}` }}>
          {typeof percentage === 'number'
            ? `${convertDigitToProperFormat(percentage)}${i18n.t('percent', { ns: 'taskManager' })}`
            : ''}
        </span>
      </NumberSection>
    </BoxWrapper>
  );
};

export default InfoBox;
